(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["hex-build-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hex-build-description')) {
    customElements.define('hex-build-description', class extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section');
        this.onBuildChange = (event) => {
          const picker = event.target.closest('variant-picker');
          if (!picker || picker.closest('.shopify-section') !== this.section) return;
          const selected = picker.querySelector('input:checked[data-variant-id], select option:checked[data-variant-id]');
          if (selected?.dataset.variantId) this.showBuild(selected.dataset.variantId);
        };
        this.section?.addEventListener('change', this.onBuildChange);
      }
      disconnectedCallback() {
        this.section?.removeEventListener('change', this.onBuildChange);
      }
      showBuild(id) {
        this.querySelectorAll('[data-build-id]').forEach(panel => {
          panel.hidden = panel.dataset.buildId !== String(id);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
